import { render } from "./AlertLayout.vue?vue&type=template&id=5b168e46&scoped=true"
import script from "./AlertLayout.vue?vue&type=script&lang=js"
export * from "./AlertLayout.vue?vue&type=script&lang=js"

import "./AlertLayout.vue?vue&type=style&index=0&id=5b168e46&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b168e46"]])

export default __exports__